import { Component,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'app/admin.service';
import { ApiService } from 'app/api.service';

@Component({
  selector: 'app-create-company-item-master-dialog',
  templateUrl: './create-company-item-master-dialog.component.html',
  styleUrls: ['./create-company-item-master-dialog.component.scss']
})
export class CreateCompanyItemMasterDialogComponent {
 item_name: string = '';
  button: boolean = true;
  isInputDisabled: boolean = false;
  type: string = '';
  viewdata: any;
  unit: any;
  unit_data: any = [];
  unit_id: any;
  hsn_id: any;
  hsn_data: any = [];
  description: string = '';
  searchUnitText: string = '';
  filteredUnitData: any[] = [];
  isItemSaved: boolean = false;
  createdItemId: number | null = null;
  category_id: any;
  category_data: any[] = [];
  savedItemId: number | null = null;
  hsn_no: any;
  global_item_id: any;
  itemId: number | null = null;
  expense_type: string = '';
  expense_types = ['Direct Expenses','Indirect Expenses'];

  constructor(
    private adminService: AdminService,
    private apiService: ApiService,
    public dialogRef: MatDialogRef<CreateCompanyItemMasterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.type = data?.type;
    this.item_name = data?.item_name || '';
    this.description = data?.description || '';
    this.unit_id = data?.unit_id || null;
    this.hsn_id = data?.hsn_id || '';

    if (this.data?.id && this.type == "View") {
      this.button = false;
      this.isInputDisabled = true;
    }
  }
  ngOnInit() {
    this.fetchunitData();
    this.fetchHsnData("item");
     this.fetchcategoryData();
  }  
  fetchunitData() {
    this.adminService.getGlobalUnit().subscribe(
      (response) => {
        this.unit_data = response;
         this.filteredUnitData = response;
         console.log('UNIT data:',this.unit_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  fetchHsnData(hsn_type: string) { //Get Hsn/Sac Data//
    this.adminService.getHsnSacType(hsn_type).subscribe(
      (response) => {
        this.hsn_data = response.data;
        console.log('HSN Data', this.hsn_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

filterUnits() {
  const search = this.searchUnitText?.toLowerCase() || '';
  this.filteredUnitData = this.unit_data.filter(unit =>
    unit.unit_name.toLowerCase().includes(search)
  );
}
  fetchcategoryData() {
    this.apiService.getCategoryByType('item').subscribe(
      (response) => {
        this.category_data = response.data;
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

 SaveItem(): void {
  const postData = {
    item_name: this.item_name,
    description: this.description,
    unit_id: this.unit_id,
    hsn_id: this.hsn_id,
  };

  if (this.data?.id) {
    this.adminService.updateGlobalItem(this.data.id, postData).subscribe(
      updatedItem => {
        alert(updatedItem.message || "Item updated successfully");
        this.dialogRef.close({ item_name: this.item_name });
      },
      error => {
        console.error("Error updating item:", error);
        alert(error.error?.message || "Error updating item");
      }
    );
  } else {
    if (!this.category_id) {
      this.isItemSaved = true;
      this.isInputDisabled = true;
      return;
    }
    this.adminService.createGlobalItem(postData).subscribe(
      response => {
        this.itemId = response.data?.id;

        const categoryPostData = {
          global_item_id: [this.itemId],
          category_id: this.category_id,
          expense_type: this.expense_type,
          auto_map: true
        };

        this.apiService.createCategoryItem(categoryPostData).subscribe(
          response => {
            if (response[0]?.original?.status === "fail") {
              alert(response[0].original.message);
            } else {
              alert("Item and Category mapped successfully!");
              this.dialogRef.close({
                item_name: this.item_name,
                category_id: this.category_id
              });
            }
          },
          error => {
            console.error("Error saving category:", error);
            alert("Error saving category");
          }
        );
      },
      error => {
        console.error("Error saving item:", error);
        alert(error.error?.message || "Error saving item");
      }
    );
  }
}


}
